
import { inject, Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TelemetryService } from '../services';

@Injectable({providedIn: 'root'})
export class VersionInterceptor implements HttpInterceptor {
	private injector = inject(Injector)

	appVersion: string;

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		return next
			.handle(request)
			.pipe(
				filter((event: HttpEvent<any>) => event instanceof HttpResponse),
				map((event: HttpResponse<any>) => {
					// play fair with streaming event backends
					if (!event.headers?.get) return event;

					const version = event.headers.get('X-AFactoring-Version');
					// ignore responses without version header
					if (! version) return event;
					if (! this.appVersion) this.appVersion = version;
					// if the api version changed, reload
					if (this.appVersion !== version) {
						console.log(`[init] reload app after version header changed`);
						this.injector.get(TelemetryService)?.event('APP_VERSION_RELOAD', { from: this.appVersion, to: version });
						location.reload();
					}
					return event;
				})
			);
	}
}
